import React, { Component } from 'react';
import { Field } from 'redux-form';
import { Row, Col } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { InputField } from '../Common/inputField';
import Spinner from '../../components/Widgets/spinner';

class PaymentTermForm extends Component {
  componentDidMount() {
    this.props.resetCreatePaymentTerm();
    this.props.resetEditPaymentTerm();
  }

  handleFormSubmit(formProps) {
    if (this.props.currentPaymentTerm) {
      if (!this.checkPermission('change_paymentterm')) {
        this.props.editPaymentTerm(formProps);
      } else { alert('You have no permission!'); }
    } else {
      this.props.createPaymentTerm(formProps);
    }
  }

  checkPermission(permission) {
    return false;
  }

  render() {
    const { handleSubmit, closePT, submitting, pristine, valid } = this.props;
    return (
      <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this))} >
        <br />
        <Row>
          <Col xs={6}>
            <div className="form-group">
              <label><Translate value="payment_term_name" /><span className="asteriksReq">*</span></label>
              <Field name="Name" component={InputField} />
            </div>
          </Col>
          <Col xs={3}>
            <div className="form-group">
              <label><Translate value="term_days" /><span className="asteriksReq">*</span></label>
              <Field name="TermDays" component={InputField} />
            </div>
          </Col>
          <Col xs={3}>
            <div className="form-group">
              <label><Translate value="term_types" /><span className="asteriksReq">*</span></label>
              <Field name="Termtype" component={InputField} />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className="form-group">
              <label><Translate value="description" /></label>
              <Field name="Description" component={InputField} />
            </div>
          </Col>
        </Row>
        <Field name="PaymentTerm_id" component="input" type="text" className="form-control" style={{ display: 'none' }} />
        <button
          action="submit"
          className="btn btn-success buttonStyle"
          disabled={submitting || pristine}
          style={{ marginTop: '25px', float: 'right' }}
        >
          <em className="fa fa-save" /><Translate value="save" />
        </button>
        { this.props.isCreating || this.props.isEditing && <Spinner/> }
        { this.props.createError && <div className="alert alert-danger marginTopStyle">{JSON.stringify(this.props.createError)}</div> }
        { this.props.editError && <div className="alert alert-danger marginTopStyle">{JSON.stringify(this.props.editError)}</div> }
      </form>
    );
  }
}

export default PaymentTermForm;



// WEBPACK FOOTER //
// ./master/jsx/components/Customers/paymentTermForm.jsx